<template>
  <div id="app">
    <div class="header" />
    <div class="content">
      <div v-if="showMap" class="mapContainer">
        <map-component :autocompleteConfig="autocompleteConfig" @error-on-map="errorOnMap"></map-component>
      </div>
    </div>
  </div>
</template>

<style>
body {
  overflow: hidden;
}
#app {
  width: 100%;
  height: 100%;
}
.header {
  height: 125px;
  line-height: 125px;
  color: white;
  text-align: center;
  background-color: #ff8200;
  font-family: "Franklin Gothic Heavy";
  font-size: 22px;
  font-style: italic;
  letter-spacing: -0.29px;
  background-position: 0 center;
  background-repeat: no-repeat;
  background-image: url("./logo_repsol.png");
}

.content {
  height: calc(100% - 125px);
  display: flex;
  flex-direction: row;
}

.mapContainer {
  width: 100%;
  height: 100%;
}

@media (max-width: 767px) {
  .header {
    height: 70px;
    line-height: 70px;
    background-size: 40%;
  }

  .content {
    height: 100%;
    flex-direction: column;
  }

  .mapContainer {
    width: 100%;
    height: 100%;
  }
}

body {
  width: 100%;
  height: 100%;
  position: absolute;
  margin: 0;
}
</style>
<script>
import axios from "axios";
import utils from "./helpers/utils";
const breakpointPX = 768;

export default {
  components: {},
  errorCaptured(err, vm, info) {
    console.log(err);
    return false;
  },
  data: function() {
    return {
      mobile: false,
      showMap: false,
      autocompleteConfig: {}
    };
  },
  methods: {
    async getConfigJSON() {
      return new Promise(resolve => {
        let data = require("./configuration.json");
        resolve(data);
      });
    },
    isMobile() {
      return utils.isMobileDevice() || this.$el.offsetWidth < breakpointPX;
    }
  },
  watch: {},
  async mounted() {
    this.mobile = this.isMobile();
    let that = this;
    window.addEventListener("resize", event => {
      that.mobile = that.isMobile();
    });
    Promise.all([this.getConfigJSON()]).then(values => {
      this.autocompleteConfig = values[0];
      this.showMap = true;
    });
  }
};
</script>



// WEBPACK FOOTER //
// demo/App.vue